import { render } from "./slidesdb_chap02.vue?vue&type=template&id=3b57b084&scoped=true"
import script from "./slidesdb_chap02.vue?vue&type=script&lang=js"
export * from "./slidesdb_chap02.vue?vue&type=script&lang=js"

import "@/assets/css/globalcn.css?vue&type=style&index=0&id=3b57b084&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b57b084"]])

export default __exports__